export default __webpack_public_path__ + "static/media/586.374fb857.jpg";